import { isNil } from "lodash";

import { Precision } from "../../types";
import calendarTypes from "../../types/calendarTypes";

const getValidPrecision = calendar => {
  switch (calendar.calendarType) {
    case calendarTypes.CALENDAR_TYPE_DATE_TIME:
      return Precision.Year;
    case calendarTypes.CALENDAR_TYPE_WEEKDAY_TIME:
      return Precision.Week;
    case calendarTypes.CALENDAR_TYPE_DAY_TIME:
      return Precision.Day;
    case calendarTypes.CALENDAR_TYPE_HOUR_TIME:
      return Precision.Second;
    default:
      return Precision.Year;
  }
};

const getPrecision = (precision, calendar, defaultPrecision) => {
  const validPrecision = getValidPrecision(calendar);
  if (isNil(precision)) {
    return isNil(defaultPrecision) ? validPrecision : defaultPrecision;
  }
  return precision <= validPrecision ? validPrecision : precision > Precision.Day ? Precision.Second : precision;
};

const getPrecisionOfDate = (date, calendar, defaultPrecision) => {
  return date
    ? getPrecision(date.precision, calendar, defaultPrecision)
    : defaultPrecision || getValidPrecision(calendar);
};

export { getPrecision, getPrecisionOfDate };
